import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const WhatsappIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M6.11,16h8v-.55A2,2,0,0,0,13,13.67a5.51,5.51,0,0,0-2.9-.67,5.49,5.49,0,0,0-2.9.67,2,2,0,0,0-1.1,1.78Zm4-4a2,2,0,0,0,1.41-3.41A1.89,1.89,0,0,0,10.11,8a2,2,0,0,0-2,2,1.92,1.92,0,0,0,.58,1.41A2,2,0,0,0,10.11,12Zm-6,8a2,2,0,0,1-1.42-.59A1.92,1.92,0,0,1,2.11,18V6a1.92,1.92,0,0,1,.58-1.41A1.91,1.91,0,0,1,4.11,4h12a1.89,1.89,0,0,1,1.41.59A1.93,1.93,0,0,1,18.11,6v4.5l4-4v11l-4-4V18a2,2,0,0,1-2,2Zm0-2h12V6h-12Zm0,0v0Z" />
    </SvgIcon>
  )
}
export default WhatsappIcon
